export const SEAT_INDUSTRIES = [
  'SaaS',
  'Hardware / Robotics',
  'AI / ML',
  'Fintech',
  'Healthcare',
  'Marketplace',
  'E-commerce',
  'Consumer',
  'Logistics',
  'Biotech',
  'Climate',
  'Edtech',
]

/** L16 advisor cadence keys (aligned with BE commitment-types advisorCadenceCommitmentTypes). */
export type SeatCommitmentOption = { key: string; label: string }

export const SEAT_COMMITMENTS: SeatCommitmentOption[] = [
  { key: 'conversations', label: 'A few conversations' },
  { key: 'on-request', label: 'Available upon request' },
  { key: 'quarterly', label: 'Quarterly meetings' },
  { key: 'monthly', label: 'Monthly meetings' },
  { key: 'part-time', label: 'Part-Time Team Member' },
  { key: 'full-time-board', label: 'Full-time board / ongoing' },
]

/** Compensation multi-select keys (BE compensation-types). */
export const SEAT_COMPENSATION_TYPES: SeatCommitmentOption[] = [
  { key: 'cash', label: 'Cash' },
  { key: 'equity', label: 'Equity' },
  { key: 'profit-share', label: 'Profit share' },
  { key: 'none', label: 'None / volunteer' },
]
